/**
 * Package access end date for student UI (list, homework, course dashboard).
 * API fields are camelCased in https.js; some fractal payloads nest the row under .data.
 */

/**
 * @param {object|null|undefined} item
 * @returns {object|null}
 */
export function resolveUserCourseRow(item) {
	if (!item || typeof item !== "object") {
		return null;
	}

	const nested = item.data;
	if (
		nested &&
		typeof nested === "object" &&
		(nested.id !== undefined ||
			nested.courseId !== undefined ||
			nested.course_id !== undefined)
	) {
		return nested;
	}

	return item;
}

/**
 * @param {string|Date|null|undefined} raw
 * @returns {string} DD.MM.YYYY or ""
 */
export function formatPackageAccessDate(raw) {
	if (!raw) {
		return "";
	}

	let str = raw;
	if (typeof raw !== "string") {
		if (raw instanceof Date && !Number.isNaN(raw.getTime())) {
			str = raw.toISOString().slice(0, 10);
		} else {
			return "";
		}
	}

	const part = str.length >= 10 ? str.slice(0, 10) : str;
	const d = part.split("-");
	if (d.length === 3) {
		return `${d[2]}.${d[1]}.${d[0]}`;
	}

	return str;
}

/**
 * @param {object|null|undefined} item raw list row or nested userCourse
 * @returns {boolean}
 */
export function shouldShowPackageAccessNotice(item) {
	const row = resolveUserCourseRow(item);
	if (!row) {
		return false;
	}

	const explicit = row.showAccessExpiryNotice;
	const snake = row.show_access_expiry_notice;
	const flag =
		explicit === undefined || explicit === null ? snake : explicit;

	if (flag !== undefined && flag !== null) {
		return !!flag;
	}

	return !!formatPackageAccessDate(
		row.accessExpiresAt || row.access_expires_at
	);
}

/**
 * List row, userCourse include, or course with nested userCourse.
 *
 * @param {object|null|undefined} item
 * @returns {object|null}
 */
export function packageAccessNoticeSource(item) {
	if (!item || typeof item !== "object") {
		return null;
	}

	const row = resolveUserCourseRow(item);
	if (
		row &&
		(row.accessExpiresAt ||
			row.access_expires_at ||
			row.showAccessExpiryNotice !== undefined ||
			row.show_access_expiry_notice !== undefined)
	) {
		return row;
	}

	if (item.userCourse) {
		return resolveUserCourseRow(item.userCourse);
	}

	return row;
}

/**
 * @param {object|null|undefined} item
 * @returns {string}
 */
export function packageAccessExpiresLabel(item) {
	const row = packageAccessNoticeSource(item);
	if (!row) {
		return "";
	}

	return formatPackageAccessDate(
		row.accessExpiresAt || row.access_expires_at
	);
}

/**
 * @param {object|null|undefined} item
 * @returns {boolean}
 */
export function shouldShowPackageAccessNoticeFor(item) {
	return shouldShowPackageAccessNotice(packageAccessNoticeSource(item));
}
